"use client";
// РУКА 2. «В корзину · цена» в карточке товара (текст из макета). Положили — кнопка ведёт в корзину.
// label — своя надпись, например «Взять аналог» (тоже из макета).
import Link from "next/link";
import { addToCart, useCart } from "./cart";
import { formatRub } from "./money";

const BASE = "block w-full text-center font-semibold rounded-card px-5 py-3 transition-colors";
const MAIN = `${BASE} bg-btn hover:bg-btn-h text-white`;
// второстепенная: товара нет, а главная кнопка рядом — «Взять аналог»
const SECOND = `${BASE} border-2 border-btn text-btn hover:bg-aq-l`;

export function AddToCartButton({
  id,
  price,
  label,
  secondary = false,
  mock = false,
}: {
  id: string;
  price: number;
  label?: string;
  secondary?: boolean;
  mock?: boolean | "wide"; // вид из макета (Р-021): true — маленькая (.b.sm, плитка), "wide" — на всю ширину (карточка)
}) {
  const CLS = mock ? `b${secondary ? " gh" : ""} ${mock === "wide" ? "wide" : "sm"}` : secondary ? SECOND : MAIN;
  const inCart = useCart().find((l) => l.kind === "product" && l.id === id);
  if (inCart) {
    return (
      <Link href="/cart" className={CLS}>
        {mock === true ? `В корзине · ${inCart.qty}` : `В корзине · ${inCart.qty} шт →`}
      </Link>
    );
  }
  return (
    <button type="button" className={CLS} onClick={() => addToCart({ kind: "product", id, qty: 1 })}>
      {label ?? (mock === true ? "В корзину" : `В корзину · ${formatRub(price)}`)}
    </button>
  );
}
